export const ORIGIN_DATA_TYPE = {
    PROPERTIES: 'PROPERTIES',
    RECT: 'RECT',
    NULL: 'NULL'
}